import { LOCALES, getLocale, setLocale, t, type Locale } from '../i18n'

export function LanguageSwitcher({ className = '' }: { className?: string }) {
  return (
    <label className={`inline-flex items-center ${className}`}>
      <span className="sr-only">{t('common.language')}</span>
      <select
        value={getLocale()}
        onChange={(e) => setLocale(e.target.value as Locale)}
        className="cursor-pointer rounded-[8px] border-0 bg-transparent py-1 pl-1.5 pr-6 text-[12.5px] font-medium text-ink-500 hover:text-ink-900 focus:outline-none focus-visible:ring-2 focus-visible:ring-ink-950/20"
      >
        {LOCALES.map((l) => (
          <option key={l.code} value={l.code}>
            {l.label}
          </option>
        ))}
      </select>
    </label>
  )
}
